<template>
<div>
  <div>
  <Main/>>
  </div>
</div>

</template>

<script>
import Main from '@/components/Main.vue'
export default {
  name: 'App',
  components: {
    Main
  }
}
</script>
<style>

body{
  background-image: url('./assets/bg.png') ;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
}

</style>
